<template>
  <div
    :id="echartId"
    style="width: 100%; height: 100%; background: #060f2b"
  ></div>
</template>
<script>
import { v4 } from 'uuid'
import * as echarts from 'echarts'
export default {
  name: 'EchartsPieColour',
  props: {
    echartsData: {
      default: () => []
    },
    title: {
      default: ''
    },
    pieClick: {
      type: Function,
      require: false
    },
    activedIndex: {
      type: Number
    },
    fromChildren: {
      type: Boolean
    }
  },
  data() {
    return {
      option: {
        title: {
          text: '游戏\n测速',
          left: 'center',
          top: 'center',
          textStyle: {
            fontSize: 14,
            color: '#82889A',
            fontWeight: 500
          }
        },
        series: [
          {
            type: 'pie',
            // hoverAnimation:false,
            emphasis: { scaleSize: 10 },
            label: {
              fontSize: 12,
              color: '#FFFFFF'
            },
            labelLine: {
              lineStyle: {
                color: '#82889A',
                width: 1,
                showAbove: true
              },
              length: 10
            },
            avoidLabelOverlap: true,
            itemStyle: {
              borderWidth: 2,
              borderColor: '#060F2B'
            },
            data: [
              {
                value: 36.8,
                name: '测试A',
                itemStyle: {
                  //normal: {
                  //颜色渐变
                  color: {
                    type: 'radial',
                    x: 0.5,
                    y: 0.5,
                    r: 0.5,
                    colorStops: [
                      { offset: 0, color: '#B5FFD6' },
                      { offset: 1, color: '#40EE8E' }
                    ],
                    globalCoord: false
                  }
                  //},
                }
              }
            ],
            radius: ['29.9%', '63.24%'],
            minAngle: 5, //最小角度
            startAngle: 30
          }
        ]
      },
      echartId: 'echart' + v4(),
      myChart: null //全局的echars对象
    }
  },
  watch: {
    echartsData() {
      this.initEchart()
    },
    title() {
      this.initEchart()
    },
    activedIndex: {
      handler(val, old) {
        if (this.myChart) {
          //之前的取消高亮
          this.myChart.dispatchAction({
            type: 'downplay',
            dataIndex: old
          })
          //新的增加高亮
          this.myChart.dispatchAction({
            type: 'highlight',
            dataIndex: val
          })
        }
      },
      deep: true
    }
  },
  methods: {
    initEchart() {
      if (this.echartsData || this.echartsData.length == 0) {
        // 颜色列表
        const colorStopList = {
          极好: [
            { offset: 0, color: '#B5FFD6' },
            { offset: 1, color: '#40EE8E' }
          ],
          极差: [
            { offset: 0, color: '#FFABA3' },
            { offset: 1, color: '#FF564D' }
          ],
          一般: [
            { offset: 0, color: '#FFF6CC' },
            { offset: 1, color: '#F6D572' }
          ],
          良好: [
            { offset: 0, color: '#B7F4FF' },
            { offset: 1, color: '#00EBFD' }
          ]
        }

        this.option.series[0].data = [...this.echartsData].map((item, index) => ({
          value: item.proportion.substring(0, item.proportion.length - 1),
          name: `${item.condition}\n${item.proportion}`,
          quality: item.condition,
          id: index,
          itemStyle: {
            //normal: {
            color: {
              type: 'radial',
              x: 0.5,
              y: 0.5,
              r: 0.5,
              colorStops: colorStopList[item.condition],
              globalCoord: false
            }
            //},
          }
        }))
        this.option.title.text = this.title
        if (this.fromChildren) {
          this.option.series[0].labelLine.length = 20
        }
      }
      this.$nextTick(() => {
        //判断图表是否已经存在再次重新渲染
        if (this.myChart != null && this.myChart != '' && this.myChart != undefined) {
          this.myChart.dispose() //销毁
        }
        this.myChart = echarts.init(document.getElementById(this.echartId), null, { renderer: 'svg' })
        this.myChart.on('finished', () => {
          if (this.activedIndex == 0 || this.activedIndex) {
            this.myChart.dispatchAction({
              type: 'highlight',
              dataIndex: this.activedIndex
            })
          }
        })
        this.myChart.setOption(this.option)
        this.$nextTick(() => {
          this.myChart.off('click', this.pieClick)
          this.myChart.on('click', this.pieClick)
        })
        window.addEventListener('resize', () => {
          console.log(this.myChart.resize)
          this.myChart.resize()
        })
      })
    }
  },
  mounted() {
    this.echartId = 'echart' + v4()
    this.initEchart()
  }
}
</script>
<style lang="less" scoped>
</style>